import { gql } from "@apollo/client";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  query GroupProjectsFromGovernments($slug: String!, $cursor: Cursor) {
    groupBySlug(slug: $slug) {
      _id
      projectsFromGovernments(limit: 6, cursor: $cursor) {
        items {
          _id
          ...ProjectCardFields
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }

  ${ProjectCardFieldsFragment}
`;
